import React from 'react';
import { useIntl } from 'react-intl';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { NextPageContext } from 'next';
import Head from '../components/Head';
import messages from '../lib/messages.mjs';
import Markdown from '../components/Markdown';
import throw404 from '../lib/throw404';
import Loader from '../components/Loader';
import correctLocalizedRoute from '../lib/correctLocalizedRoute';
import useMarkdownLoader from '../lib/useMarkdownLoader';

const markdownImports = {
  'nl-NL': () => import('../data/staticPages/statistics/netherlands.md'),
  'de-DE': () => import('../data/staticPages/statistics/germany.md'),
  'en-GB': () => import('../data/staticPages/statistics/uk.md'),
  'es-ES': () => import('../data/staticPages/statistics/spain.md'),
  'fr-FR': () => import('../data/staticPages/statistics/france.md'),
  'en-IN': () => import('../data/staticPages/statistics/india.md'),
  'it-IT': () => import('../data/staticPages/statistics/italy.md'),
  'es-PE': () => import('../data/staticPages/statistics/peru.md'),
  'es-CO': () => import('../data/staticPages/statistics/colombia.md'),
  'es-AR': () => import('../data/staticPages/statistics/argentina.md'),
  'es-CL': () => import('../data/staticPages/statistics/chile.md'),
} as const;

const CountryStatistics = () => {
  const intl = useIntl();
  const { markdown, loading } = useMarkdownLoader(markdownImports);

  if (loading) return <Loader fullScreen />;

  if (!markdown) return throw404();

  return (
    <>
      <Head
        title={intl.formatMessage(
          messages['localizedFashionIndustryStatistics.title'],
        )}
        description={intl.formatMessage(
          messages['localizedFashionIndustryStatistics.description'],
        )}
      />
      <StaticPageComponent
        breadcrumbs={[]}
        content={(
          <Markdown markdown={markdown} allowHtml allowGfm />
        )}
        title={intl.formatMessage(
          messages['localizedFashionIndustryStatistics.title'],
        )}
        withTableStyles
      />
    </>
  );
};

CountryStatistics.getInitialProps = (context: NextPageContext) => {
  correctLocalizedRoute(context, 'country-statistics');
  return {};
};

export default CountryStatistics;
